import { VNode } from 'vue'

export type ToastType = 'default' | 'dark' | 'primary' | 'success' | 'danger'

export interface ToastAction {
    label: string
    primary?: boolean
    onClick: () => void
}

export class Toast {
    id: number
    label: string
    description?: string
    timeout?: number
    timeoutId?: number
    type: ToastType
    icon?: VNode
    closable: boolean
    actions: ToastAction[]
    onClose?: () => void

    constructor(payload: Partial<Toast>) {
        this.id = Math.random()
        this.label = payload.label ?? ''
        this.description = payload.description
        this.timeout = payload.timeout ?? 3000
        this.timeoutId = payload.timeoutId
        this.type = payload.type ?? 'default'
        this.icon = payload.icon
        this.closable = payload.closable ?? false
        this.actions = payload.actions ?? []
        this.onClose = payload.onClose
    }
}

export interface ToastShowOptions {
    label: string
    description?: string
    // 0 keeps the toast open until it is hidden or closed
    timeout?: number
    type?: ToastType
    icon?: VNode
    closable?: boolean
    actions?: ToastAction[]
    // Called when the user closes the toast from its close button
    onClose?: () => void
}
